module.exports = __webpack_public_path__ + "img/mineral_beige_ba_list.917c5b05.jpg";